import BaseModel from './base-model';
/**
 * format:
 * @REL_ATTR: 400312
 * @COMMON_NAME: "Notificaciones bienvenida"
 * @id: 400312
 */
export default class PrimaryIndex extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
